import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Alert, Checkbox, FormControlLabel, IconButton } from "@mui/material"
import { cloneDeep } from "lodash"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import CloseIcon from "@mui/icons-material/Close"
import { createOccupationArea, updateOccupationArea } from "../../../../services/apiKYE"
import { OPERATION_MESSAGES } from "../../../../utils/constants/operations"


const initialState = {
  name: '',
  score: 1,
  active: true,
}

const initialErrors = {
  name: false,
  score: false,
}

const OccupationAreaFormDialog = (props) => {
  const { occupation_area, handleClose, open } = props

  const token = useSelector((state) => state.auth.access_token)
  const isEditMode = occupation_area !== undefined && occupation_area !== null
  const [formState, setFormState] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialErrors)

  const handleChange = useCallback((event) => {
    const { id, value, checked } = event.target

    if (id === 'active') {
      setFormState((prevState) => ({
        ...prevState,
        [id]: checked,
      }))
    } else {
      setFormState((prevState) => ({
        ...prevState,
        [id]: value,
      }))
    }
  }, [])

  const validate = () => {
    const errors = cloneDeep(initialErrors)

    Object.keys(errors).forEach((key) => {
      if (formState[key] === '') errors[key] = true
    })

    if (Object.keys(errors).some((key) => errors[key])) {
      setFormErrors(errors)
      toast.error(OPERATION_MESSAGES.CHECK_INFORMED_DATA)
      return false
    }

    return true
  }

  const clearAndClose = () => {
    setFormState(initialState)
    setFormErrors(initialErrors)
    handleClose()
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const data = cloneDeep(formState)

    if (!validate())
      return

    if (isEditMode) {
      updateOccupationArea(
        token, occupation_area.uuid, data,
      ).then((response) => {
        if (response === '') {
          toast.success(OPERATION_MESSAGES.RECORD_UPDATE_SUCCESS)
          clearAndClose()
        }
      })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_UPDATE_FAIL)
        })
        .finally(() => {

        })
    } else {
      createOccupationArea(token, data)
        .then((response) => {
          if (response) {
            toast.success(OPERATION_MESSAGES.RECORD_ADD_SUCCESS)
            clearAndClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_ADD_FAIL)
        })
        .finally(() => {

        })
    }
  }

  useEffect(() => {
    if (occupation_area) {
      setFormState(occupation_area)
    } else {
      setFormState(initialState)
    }
  }, [occupation_area])

  return (
    <Dialog open={open} fullWidth={true}>
      <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Área de ocupação
        <IconButton
          aria-label="close"
          onClick={clearAndClose}
          sx={{
            position: 'absolute',
            right: '1.3rem',
            top: '1.3rem',
            color: (theme) => theme.palette.primary,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Informe abaixo, os dados da área de ocupação.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Descrição"
          type="text"
          fullWidth
          variant="standard"
          disabled={isEditMode}
          required
          onChange={handleChange}
          value={formState.name}
          error={formErrors.name}
        />

        <TextField
          margin="dense"
          id="score"
          label="Score"
          type="number"
          fullWidth
          required
          variant="standard"
          inputProps={{
            min: 1,
            max: 4,
          }}
          onChange={handleChange}
          value={formState.score}
          error={formErrors.score}
        />

        {isEditMode && (
          <React.Fragment>
            <FormControlLabel
              control={
                <Checkbox
                  id="active"
                  checked={formState.active}
                  onChange={handleChange}
                />
              }
              label="Ativo"
            />
            <Alert severity="warning">
              Áreas de ocupação desativadas não são levadas em consideração no cálculo da pontuação do background check.
            </Alert>
          </React.Fragment>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={clearAndClose}>Cancelar</Button>
        <Button style={{ margin: "1.2rem" }} onClick={handleSubmit} variant='contained'>Confirmar</Button>
      </DialogActions>
    </Dialog>
  )
}

export default OccupationAreaFormDialog
